var version = "2.2.3";

export { version };
